import CompanyRoutes from "../../../apiRoutes/CompanyRoutes";
import { api } from "../../ConsumeApiController";


export async function getSubscriptions(planId = null) {
    try {
        let url = CompanyRoutes.Subscriptions.Subscriptions.getAll;
        if (planId) {
            url += `?plan_id=${planId}`; // Necesitaremos ajustar el backend para esto
        }
        const response = await api.get(url);
        return response;
    } catch (error) {
        return { success: false, message: error.message };
    }
}


/*
|--------------------------------------------------------------------------
| ENROLL STUDENT
|--------------------------------------------------------------------------
| EN - Creates a new subscription.
| ES - Crea una nueva suscripción (inscribe un alumno).
*/
export async function enrollStudent(data) {
    try {
        const url = CompanyRoutes.Subscriptions.Subscriptions.create;
        const response = await api.post(url, data);
        return response;
    } catch (error) {
        return { success: false, message: error.message };
    }
}


export async function searchCustomers(query) {
    try {
        const url = CompanyRoutes.CRM.Customers.search(query);
        const response = await api.get(url);
        return response;
    } catch (error) {
        return { success: false, message: error.message, data: [] };
    }
}

/*
|--------------------------------------------------------------------------
| CREATE QUICK CUSTOMER
|--------------------------------------------------------------------------
| EN - Creates a new customer via the CRM endpoint.
| ES - Crea un nuevo cliente a través del endpoint de CRM.
*/
export async function createQuickCustomer(data) {
    try {
        // Apunta a la ruta que definimos en api.php: 
        // Route::prefix('crm')->prefix('customers')->post('/', ...)
        const url = CompanyRoutes.CRM.Customers.create;
        
        // 'data' contiene: { name, last_name, email, phone, create_user }
        const response = await api.post(url, data);
        
        return response;
    } catch (error) {
        return { success: false, message: error.message };
    }
}

export async function cancelSubscription(id) {
    try {
        const url = CompanyRoutes.Subscriptions.Subscriptions.cancel(id);
        const response = await api.post(url);
        return response;
    } catch (error) {
        return { success: false, message: error.message };
    }
}


export async function getSubscriptionStatistics() {
    try {
        const url = CompanyRoutes.Subscriptions.Subscriptions.statistics();
        console.log('LA RUTA ES ===> ',url);
        const response = await api.get(url);
        return response;
    } catch (error) {
        return { success: false, message: error.message };
    }
}